import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './pagoNubeOnboarding.es-AR.json';
import esMX from './pagoNubeOnboarding.es-MX.json';
import ptBR from './pagoNubeOnboarding.pt-BR.json';

const pagoNubeOnboardingTranslations: DomainTranslations = {
  name: 'pagoNubeOnboarding',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default pagoNubeOnboardingTranslations;
